export default __webpack_public_path__ + "static/media/ChinaTree.f021b54d.jpg";